export default "__VITE_PUBLIC_ASSET__a1b8ab5a__"